import { getOrgId } from '@/utilities/stytch/getOrgId'
import userService from '@/services/patient/user'
import { withAnalyticsTracking } from '@/utilities/analytics/apiAnalytics'
import { trackEvent } from '@/utilities/analytics/trackEvent'
import { errorAnalyticsPayload } from '@/utilities/analytics/errorAnalytics'
import { setOnboardingIncompleteCookie, clearOnboardingCookie } from '@/utilities/onboardingCookie'

export type PostLoginRedirectResult = {
  redirectUrl: string
  isFirstTimeUser: boolean | null
}

export async function determinePostLoginRedirect(args?: {
  email?: string
}): Promise<PostLoginRedirectResult> {
  try {
    const organizationId = getOrgId()
    const email = args?.email ?? ''
    const discoveryResult = await withAnalyticsTracking(
      () => userService.fetchUserDiscovery(email, organizationId),
      { eventName: 'login:user_discovery_api' },
    )

    if (!discoveryResult.is_discovered) {
      setOnboardingIncompleteCookie()
      return { redirectUrl: '/welcome', isFirstTimeUser: true }
    }

    clearOnboardingCookie()
    return { redirectUrl: '/home', isFirstTimeUser: false }
  } catch (error) {
    trackEvent('login:user_discovery_fail', {
      ...errorAnalyticsPayload(error),
    })
    clearOnboardingCookie()
    return { redirectUrl: '/home', isFirstTimeUser: null }
  }
}
